import styled from 'styled-components';
import RecoverPwdLanding from './RecoverPwdLanding';
import { media, colorSchema } from 'utils/style';
import passwordRecovery from 'assets/images/passwordRecovery.svg';

export default styled(RecoverPwdLanding)`
  height: 100%;
  .recover-pwd-landing {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
    height: 100%;
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(12, 1fr);
    `}

    &__background {
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        background: url(${passwordRecovery}) no-repeat 100% 0;
        grid-column: 3 / span 8;
        grid-row: 1;
        margin: 10rem 0;
      `}
    }

    &__loading-container {
      display: flex;
      justify-content: center;
      margin: 2rem 0;
      grid-column: 1 / span 12;
      grid-row: 1;
    }

    &__container {
      ${media.greaterThan('tablet')`
        max-width: 372px;
        padding: 2rem 0;
      `}
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 3.2rem;
      font-weight: normal;
      line-height: 1.19;
      margin-bottom: 1.6rem;
    }

    &__text {
      color: ${colorSchema('grey700')};
      font-size: 2rem;
      line-height: 1.3;
      margin-bottom: 2.4rem;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
    }

    &__password {
      font-size: 1.8rem;
      font-weight: bold;
    }

    &__submit {
      border-radius: 4px;
    }
  }
`;
